import { Box, Skeleton, Card, CardContent } from '@mui/material';
import { HeaderContainer } from '../dashboard/AgentInfoHeader';
import LayoutWithSidebar from '../common/layoutWithSidebar';

const JobDetailSkeleton = () => {
  return (
    <LayoutWithSidebar margin={0}>
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        {/* Header */}
        <HeaderContainer
          sx={{
            borderRadius: 0,
            border: 'none',
            borderBottom: '1px solid #DCE0E7',
            margin: 0,
            pb: 0,
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {/* Back button and title */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Skeleton
                variant="circular"
                width={24}
                height={24}
                sx={{ minWidth: 24 }}
              />
              <Box sx={{ flex: 1 }}>
                <Skeleton
                  variant="text"
                  width={200}
                  height={32}
                  sx={{ mb: 0.5 }}
                />
                <Skeleton variant="text" width={150} height={20} />
              </Box>
            </Box>

            {/* Status Cards */}
            <Box sx={{ display: 'flex', gap: 2, pb: 2 }}>
              {/* Status Card */}
              <Card
                sx={{
                  minWidth: 120,
                  borderRadius: 2,
                  boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                }}
              >
                <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      mb: 1,
                    }}
                  >
                    <Skeleton variant="circular" width={16} height={16} />
                    <Skeleton variant="text" width={40} height={16} />
                  </Box>
                  <Skeleton variant="text" width={60} height={24} />
                </CardContent>
              </Card>

              {/* Duration Card */}
              <Card
                sx={{
                  minWidth: 140,
                  borderRadius: 2,
                  boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                }}
              >
                <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      mb: 1,
                    }}
                  >
                    <Skeleton variant="circular" width={16} height={16} />
                    <Skeleton variant="text" width={50} height={16} />
                  </Box>
                  <Skeleton variant="text" width={80} height={24} />
                </CardContent>
              </Card>

              {/* Start Time Card */}
              <Card
                sx={{
                  minWidth: 180,
                  borderRadius: 2,
                  boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                }}
              >
                <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                  <Skeleton
                    variant="text"
                    width={60}
                    height={16}
                    sx={{ mb: 1 }}
                  />
                  <Skeleton variant="text" width={140} height={20} />
                </CardContent>
              </Card>

              {/* End Time Card */}
              <Card
                sx={{
                  minWidth: 180,
                  borderRadius: 2,
                  boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                }}
              >
                <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                  <Skeleton
                    variant="text"
                    width={60}
                    height={16}
                    sx={{ mb: 1 }}
                  />
                  <Skeleton variant="text" width={140} height={20} />
                </CardContent>
              </Card>
            </Box>
          </Box>
        </HeaderContainer>

        {/* Main Content Area - Flow Skeleton */}
        <Box sx={{ flex: 1, overflow: 'hidden', p: 3 }}>
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
            }}
          >
            {/* Flow Nodes Skeleton */}
            <Box
              sx={{
                display: 'flex',
                gap: 3,
                flexWrap: 'wrap',
                alignItems: 'flex-start',
              }}
            >
              {/* Simulate flow nodes */}
              {[1, 2, 3, 4].map(index => (
                <Box
                  key={index}
                  sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}
                >
                  <Skeleton
                    variant="rectangular"
                    width={200}
                    height={80}
                    sx={{ borderRadius: 2 }}
                  />
                  <Skeleton variant="text" width={150} height={16} />
                </Box>
              ))}
            </Box>

            {/* Additional flow elements */}
            <Box sx={{ mt: 4 }}>
              <Skeleton
                variant="rectangular"
                width="100%"
                height={200}
                sx={{ borderRadius: 2 }}
              />
            </Box>

            {/* Bottom section */}
            <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
              <Skeleton
                variant="rectangular"
                width={150}
                height={60}
                sx={{ borderRadius: 1 }}
              />
              <Skeleton
                variant="rectangular"
                width={150}
                height={60}
                sx={{ borderRadius: 1 }}
              />
              <Skeleton
                variant="rectangular"
                width={150}
                height={60}
                sx={{ borderRadius: 1 }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </LayoutWithSidebar>
  );
};

export default JobDetailSkeleton;
